export const MuiSelect = {
  styleOverrides: {
    root: {
      width: '100%',
      fontWeight: 600,

      '.MuiSelect-outlined': {
        padding: '5.5px 10px',
      },

      '.MuiSvgIcon-root': {
        color: 'rgba(159, 159, 159, 1)',
      },

      '.MuiSelect-iconOpen': {
        color: 'rgba(34, 40, 34, 1)',
      },
    },
  },
};
